"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("../styles");

var styles = function styles(theme) {
  var _logoContainer;

  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    iconContainer: {
      display: "flex",
      alignItems: "center",
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(10),
      minHeight: theme.mixins.toolbar.minHeight,
      position: "relative",
      "& > svg": {
        maxWidth: "100%",
        zIndex: "2"
      }
    },
    logoContainer: (_logoContainer = {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minHeight: theme.mixins.toolbar.minHeight,
      transition: theme.transitions.create("min-height", {
        duration: theme.transitions.duration.complex,
        delay: theme.transitions.duration.standard
      })
    }, (0, _defineProperty2.default)(_logoContainer, theme.breakpoints.up("sm"), {
      minHeight: theme.mixins.toolbar.minHeight + theme.spacing(3.5)
    }), (0, _defineProperty2.default)(_logoContainer, "width", _styles.mainPanelWidth), (0, _defineProperty2.default)(_logoContainer, "flexShrink", 0), (0, _defineProperty2.default)(_logoContainer, "boxSizing", "border-box"), _logoContainer),
    canBeClicked: {
      cursor: "pointer",
      zIndex: theme.zIndex.appBar
    },
    arrowContainer: {
      right: "1rem",
      position: "absolute",
      zIndex: 2,
      "& svg": {
        transition: "transform 240ms"
      }
    },
    arrowContainerOpen: {
      "& svg": {
        transform: "scaleY(-1)"
      }
    },
    logo: {
      maxWidth: "100%",
      padding: theme.spacing(4),
      objectFit: "contain",
      "@media (max-height: 600px)": {
        maxHeight: "100px",
        padding: theme.spacing(1),
        margin: "0 auto"
      },
      maxHeight: "inherit"
    },
    logoMaxHeight: {
      maxHeight: "inherit",
      padding: theme.spacing(1),
      margin: "0 auto"
    },
    logoContainerMaxHeight: (0, _defineProperty2.default)({
      maxHeight: theme.mixins.toolbar.minHeight + theme.spacing(3.5)
    }, theme.breakpoints.down("xs"), {
      maxHeight: theme.mixins.toolbar.minHeight
    })
  };
};

exports.styles = styles;